import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Hammer, Flame } from 'lucide-react';
import { IMAGES } from '../mock';

const About = () => {
  return (
    <div className="bg-black text-white">
      <section
        className="relative pt-40 pb-24"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.9), rgba(0,0,0,0.7)), url(${IMAGES.workshop})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="font-display tracking-[0.3em] text-xs text-[#FF6B00] font-semibold mb-3">ABOUT US</div>
          <h1 className="font-display text-5xl md:text-7xl tracking-tight max-w-3xl">DRIVEN BY PASSION. DEFINED BY PRECISION.</h1>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <h2 className="font-display text-3xl md:text-4xl tracking-tight mb-6">OUR STORY</h2>
            <div className="h-[2px] w-16 bg-[#FF6B00] mb-6" />
            <p className="text-neutral-300 mb-4 leading-relaxed">
              Fortune Auto Design was founded by a crew of obsessive enthusiasts tired of compromise. We wanted carbon parts that fit like factory, finished like concours, and performed like race-bred hardware.
            </p>
            <p className="text-neutral-300 mb-4 leading-relaxed">
              Today we are North America&rsquo;s destination for premium carbon fiber bodykits, bespoke forged wheels and full custom fabrication. We partner with iconic brands like DarwinPro, Paktechz, Sooqoo and Karbel &mdash; and design our own in-house line, Fortune Forged.
            </p>
            <p className="text-neutral-300 leading-relaxed">
              Every project we take on is treated as a flagship. That&rsquo;s the Fortune standard.
            </p>
          </div>
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden">
              <img src={IMAGES.fabrication} alt="Fabrication" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#FF6B00] text-white p-6 max-w-[220px] hidden md:block">
              <div className="font-display text-3xl font-bold">10+</div>
              <div className="font-display tracking-[0.2em] text-xs mt-1">YEARS BUILDING LEGENDS</div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-neutral-950 border-y border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-10">
          {[
            { icon: Target, title: 'OUR MISSION', desc: 'Deliver parts and builds that set the benchmark for quality, fitment and performance.' },
            { icon: Hammer, title: 'OUR CRAFT', desc: 'Pre-preg dry carbon, CNC machining, hand-laid composites and autoclave-cured perfection.' },
            { icon: Flame, title: 'OUR PROMISE', desc: 'If it leaves our shop, it\u2019s ready to perform. No shortcuts. No excuses.' },
          ].map((v) => (
            <div key={v.title} className="p-8 border border-white/10 hover:border-[#FF6B00]/60 transition-colors">
              <v.icon className="text-[#FF6B00] mb-5" size={32} strokeWidth={1.5} />
              <h3 className="font-display tracking-[0.2em] text-sm font-bold mb-3">{v.title}</h3>
              <p className="text-neutral-400 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
          <h2 className="font-display text-3xl md:text-5xl tracking-tight mb-6">READY TO START YOUR BUILD?</h2>
          <p className="text-neutral-400 max-w-xl mx-auto mb-8">Book a consultation with our team and let&rsquo;s bring your vision to life.</p>
          <Link to="/contact" className="inline-block bg-[#FF6B00] hover:bg-[#E25500] transition-colors px-8 py-4 font-display tracking-[0.22em] text-sm font-bold">
            CONTACT OUR TEAM
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
